/**
 * Захист від open-redirect для return-url (ADR-0006 D5).
 *
 * Приймає ЛИШЕ relative same-origin шлях: починається з одинарного `/`, але не
 * `//` (protocol-relative), без scheme (`http:`/`javascript:`), без backslash-обходу
 * чи керівних символів. Усе інше → дефолт `/`. Тому `?return=//evil.com`,
 * `https://evil.com`, `javascript:…` ніколи не дають зовнішнього редіректу.
 */
export function safeReturnPath(raw: unknown): string {
  if (typeof raw !== "string" || raw.length === 0) {
    return "/";
  }
  // нормалізуємо backslash (деякі браузери трактують \ як /)
  const value = raw.replace(/\\/g, "/");
  if (!value.startsWith("/") || value.startsWith("//")) {
    return "/";
  }
  // відкидаємо керівні символи C0 та пробіл (обхід "/\t/evil", CRLF-інʼєкція)
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) <= 0x20) {
      return "/";
    }
  }
  return value;
}
